<ng-container>
  <oneplace-header [data]="oneplaceHeaderOptions" />
</ng-container>
